import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/UserTransaction`;


const ApiUserTransaction = {

  getAllUserTransaction: (params) => {
    const url = `${baseServiceUrl}/getAllUserTransaction`;
    return ServiceApi.get(url, { params });
  },

};

export default ApiUserTransaction;